import React, { Component } from 'react';
import PMTaskGroups from './PMTaskGroups';
import UserAssignmentContainer from '../../../../containers/projectmanager/UserAssignmentContainer';
import PMWorkloadContainer from '../../../../containers/projectmanager/PMWorkloadContainer';

class PMTGS extends Component {

	render() {
		const p = this.props;
		const { view } = p.state;
		return (
			<div className={"PMTGS"}>

				<div className={"content_header"}>

					<div className={"content_header_helper"}>
						<div onClick={p.goBack}><span className="icon">&#x25C0;</span>{"Back"}</div>
					</div>
				</div>

				{this.details()}
				{this.tabs()}
				{view === 'planning' ? this.taskPlanning() : null}
				{view === 'users' ? this.userAssignment() : null}
				{view === 'workload' ? this.workload() : null}
				{view === 'view4' ? this.taskPlanning() : null}
			</div>
		);
	}

	details = () => {
		const p = this.props;
		const { currentItem } = p.state;

		return (
			<div className={"PMTGSDetails"}>
				<h1>{currentItem.display}</h1><h3>Project: {currentItem.project} | BP: {currentItem.bp} | {currentItem.description} </h3>
			</div>
		)
	}

	tabs = () => {
		const p = this.props;
		const { view } = p.state;
		return (
			<div className={"PMTGSTabs"}>
				<div className={view === 'planning' ? "PMTGSTabActive" : "PMTGSTab"} onClick={() => p.setView('planning')}>
					Task Planning
				</div>
				<div className={view === 'users' ? "PMTGSTabActive" : "PMTGSTab"} onClick={() => p.setView('users')}>
					User Assignment
				</div>
				<div className={view === 'workload' ? "PMTGSTabActive" : "PMTGSTab"} onClick={() => p.setView('workload')}>
					Workload
				</div>
				<div className={view === 'view4' ? "PMTGSTabActive" : "PMTGSTab"} onClick={() => p.goToDesktop()}>
					Desktop
				</div>
			</div>
		)
	}

	taskPlanning() {
		return (
			<div>
				<PMTaskGroups colParam={'uniqueID'} />
			</div>
		);
	}

	userAssignment() {
		return (
			<div>
				<UserAssignmentContainer colParam={'assigned'} />
			</div>
		);
	}

	workload() {
		return (
			<div>
				<PMWorkloadContainer colParam={'assigned'} />
			</div>
		);
	}

}

export default PMTGS;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/TaskGroup/PMTGS.js